import { render, staticRenderFns } from "./CPVSelect.vue?vue&type=template&id=117da456&scoped=true"
import script from "./CPVSelect.vue?vue&type=script&lang=js"
export * from "./CPVSelect.vue?vue&type=script&lang=js"
import style0 from "./CPVSelect.vue?vue&type=style&index=0&id=117da456&prod&scoped=true&lang=css"
import style1 from "@/assets/CatalogSelect.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117da456",
  null
  
)

export default component.exports